﻿﻿import { IProductCenter } from './product-center';

export interface ICenterProducts {
    centerId: number;
    centerAlias: string;
    nkrLiaison: string;
    executiveSponsor: string;
    products: IProductCenter[];
}
